module.exports = "<div class=\"modal\">\r\n    <div class=\"modal-open\">\r\n      <iframe class=\"iframe-div\" [src]=\"mediaLibraryUrl | sanitizeUrl\"></iframe>\r\n    </div>\r\n</div> "


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/media-library/media-library.component.html
// module id = ./src/app/shared/components/media-library/media-library.component.html
// module chunks = main